export const QUOTA_CONFIG = {
    FREE_TIER_CHARS: 10000
  };

export const REQUEST_CONFIG = {
  MAX_CHARAS_PER_REQUEST: 4500
};